var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modpack--list-wrapper",
      on: {
        click: function ($event) {
          return _vm.emit("on-mod-selected", _vm.value)
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "modpack--list-buy" },
        [
          _c("font-awesome-icon", {
            attrs: { icon: ["far", "plus"], size: "sm" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "modpack--list-container" }, [
        _c("div", { staticClass: "modpack--list-image-wrapper" }, [
          _c(
            "div",
            { staticClass: "modpack--list-image" },
            [_c("base-modpack-image", { attrs: { value: _vm.value } })],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "modpack--list-content" }, [
          _c("div", { staticClass: "modpack--list-title" }, [
            _vm._v("\n        " + _vm._s(_vm.value.name) + "\n      "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modpack--list-ram" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.i18n.t("general:ram.units.recommended", {
                    units: Math.ceil(_vm.value.ram / 1024),
                    unitName: "GB",
                  })
                ) +
                "\n      "
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.value.tags.length
        ? _c("base-modpack-tag-list", {
            attrs: { "mod-tags": _vm.value.tags, tags: _vm.state.tags },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }